// removed by extract-text-webpack-plugin
module.exports = {"nf-u-details__grid":"nf-u-details__grid","nf-solicitation-detail__card":"nf-solicitation-detail__card","nf-solicitation-detail__card-header":"nf-solicitation-detail__card-header","nf-solicitation-detail__card-body":"nf-solicitation-detail__card-body","rt-resizable-header-content":"rt-resizable-header-content","floating-back":"floating-back","mybutton":"mybutton","mybutton2":"mybutton2","tooling-gov-comment":"tooling-gov-comment","title-gov-comment":"title-gov-comment","sendRFQ":"sendRFQ","sendRFQ2":"sendRFQ2"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/universalDetails/UniversalDetails.scss
// module id = 5060
// module chunks = 1